const DEBE = 'DEB'
const HABER = 'HAB'

const __dictionary = {
  [DEBE]: {
    id: DEBE,
    nombre: 'DEBE'
  },
  [HABER]: {
    id: HABER,
    nombre: 'HABER'
  }
}

const __array = [__dictionary[DEBE], __dictionary[HABER]]

export default Object.freeze({
  DEBE,
  HABER,
  __dictionary,
  __array
})
